module.exports = __webpack_public_path__ + "static/img/41.b41a5e80.png";